import { capitalize } from "lodash";
import moment from "moment";
import { useState } from "react";
import { HelpBlock } from "react-bootstrap";
import { SingleDatePicker } from "react-dates";
import { NoEndDate, SingleDatePickerWrapper } from "./styles";


export const DatePickerField = ({
  date,
  field,
  form,
  placeholder,
  intl,
  onDateChange,
  className = '',
  disabled = false,
  clearable = false,
  noEndDateText = "no.end.date",
  showInputIcon = false,
  isOutsideRange = () => false,
  startDate,
  anchorDirection,
  openDirection
}) => {
  const [focused, setFocused] = useState(false);

moment.locale(intl.locale);

  const hasSelectedDate = (value) => {
    if (value === null || value === undefined || value === '') {
      return false;
    }

    return moment(value).isValid();
  };

  const handleClear = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onDateChange(null);
    form.setFieldValue(field.name, null);
    setFocused(false);
  };

  const renderCalendarInfo = () => {
    if (!clearable || disabled || !hasSelectedDate(date)) {
      return null;
    }

    return (
      <div
        style={{
          padding: '6px 12px 10px',
          display: 'flex',
          justifyContent: 'center',
          borderTop: '1px solid #F0F1F3'
        }}
      >
        <button
          type="button"
          onClick={handleClear}
          style={{
            background: 'none',
            border: 'none',
            color: '#0095FF',
            fontFamily: 'Montserrat SemiBold, sans-serif',
            fontSize: '12px',
            cursor: 'pointer',
            padding: '4px 6px'
          }}
        >
          {intl.formatMessage({ id: 'common.clear', defaultMessage: 'Clear' })}
        </button>
      </div>
    );
  };

  return (
    <SingleDatePickerWrapper focused={focused} className= {className + ' ' + (form.touched[field.name] && form.errors[field.name] ? 'date-picker-error-wrapper': "")}>
      <SingleDatePicker
        date={date}
        onDateChange={(currentDate) => {
          onDateChange(currentDate);
          form.setFieldValue(field.name, currentDate);
        }}
        focused={focused}
        locale={intl.locale}
        onFocusChange={({ focused }) => {
          setFocused(focused);
        }}
        id={field.name}
        numberOfMonths={1}
        isDayBlocked={(day) => {
          return startDate && day.isBefore(startDate);
        }}
        disabled={disabled}
        readOnly={true}
        isOutsideRange={isOutsideRange}
        placeholder={placeholder}
        displayFormat={() => intl.formatMessage({ id: "dateFormat" })}
        anchorDirection={anchorDirection || "right"}
        openDirection= {openDirection ||"up"}
        renderMonthElement={({ month }) => (
          <div style={{ display: "flex", justifyContent: "center" }}>
            {capitalize(moment.months()[month.month()]) + " " + month.year()}
          </div>
        )}
        renderCalendarInfo={clearable ? renderCalendarInfo : undefined}
        customInputIcon={
          showInputIcon && !date && !focused ? (
            <NoEndDate>
              {intl.formatMessage({
                id: noEndDateText,
              })}
            </NoEndDate>
          ) : null
        }
      />
      {form.touched[field.name] && form.errors[field.name] ? (
        <HelpBlock style={{ color: "var(--red-50, #FC2C03)" }}>
          {form.errors[field.name]}
        </HelpBlock>
      ) : null}
    </SingleDatePickerWrapper>
  );
};
